import type { TravelGuideContactInfo } from '../../domain/types'
import type { BookingDetailsContactInformationAPIResponse } from '../types'

export function travelGuideMapper(contactInformation: BookingDetailsContactInformationAPIResponse | undefined): TravelGuideContactInfo | null {
  const travelGuide = contactInformation?.travelGuide
  if (!travelGuide) {
    return null
  }
  return {
    phoneNumber: travelGuide.phoneNumber ?? '',
    workingHours: travelGuide.workingHours ?? '',
    visitingHours: (travelGuide.visitingHours ?? []).map(vh => ({
      name: vh.name ?? '',
      location: vh.location ?? '',
      date: vh.date ?? '',
      startTime: vh.startTime ?? '',
      endTime: vh.endTime ?? '',
    })),
  }
}
